<template>
  <v-dialog v-model="dialog" max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" icon>
        <v-icon>mdi-archive-search-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold"
        >Pedido {{ pedido.nr_pedido }}</v-card-title
      >
      <v-card-subtitle>{{ pedido.nome_cliente }}</v-card-subtitle>
      <v-card-text>
        <v-data-table
          :items="pedido.itens"
          :headers="headers"
          hide-default-footer
          dense
          disable-sort
          no-data-text="Nenhum item encontrado"
        >
          <template v-slot:[`item.produto`]="{ item }">
            <span :title="`${item.gp}-${item.sgp}-${item.item}`"
              >{{ item.produto }} ({{ item.gp }}-{{ item.sgp }}-{{
                item.item
              }})</span
            >
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text @click="dialog = false" :block="isMobile()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    pedido: { type: Object, required: true },
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Produto", value: "produto" },
      { text: "Emb", value: "emb" },
      { text: "Qtde Kgs", value: "qtde_kgs" },
      { text: "Saldo(Kgs)", value: "qtde_usar" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>